import React from "react";
//#region types
import { SelectionItem } from "models/utilTypes/selectionTypes";
//#endregion
function useMultiSelectionHelpers(list: SelectionItem[], value?: SelectionItem[]) {
  const [items, setItems] = React.useState<SelectionItem[]>([]);

  React.useEffect(() => {
    setSelectedItems();
  }, [list, value]);

  const setSelectedItems = () => {
    setItems(value ? list.map((item) => ({ ...item, selected: value?.some((x) => x.id === item.id) })) : list);
  };
  return { items };
}

export default useMultiSelectionHelpers;
